// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Stack } from "@mui/system";
import {
  FormControl,
  Autocomplete,
  TextField,
  useTheme,
  useMediaQuery,
  InputAdornment,
} from "@mui/material";
import { Button, Loading } from "../../atoms";
import {
  useGetAllMerchantList,
  useGetInstallmentCountSettingsList,
  useGetCurrencyCodeList,
  useGetPaymentModelSettingsList,
  usePaymentPreAuth,
  IPaymentPreAuthRequest,
  useAuthorization,
  useGetBankInstallments,
  useGetMerchantRestrictionList,
} from "../../../hooks";
import { useEffect, useMemo, useState } from "react";
import {
  InputControl,
  FormatInputControl,
  SelectControl,
  NumericFormatInputControl,
  BaseModalFor3d,
} from "../../molecules";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  addPreAuthFormSchema,
  PreAuthAddFormValuesType,
  initialPreAuthState,
} from "./_formTypes";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { useUserInfo } from "../../../store/User.state";
import { v4 as uuidv4 } from 'uuid';

export const PreAuthAddForm = () => {
  const [html, setHtml] = useState();
  const [isHtmlOpen, setIsHtmlOpen] = useState(false);
  const { showCreate } = useAuthorization();
  const [userInfo] = useUserInfo();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { control, handleSubmit, watch, setValue } = useForm<PreAuthAddFormValuesType>({
    resolver: zodResolver(addPreAuthFormSchema),
    defaultValues: initialPreAuthState,
  });
  const setSnackbar = useSetSnackBar();

  const { data: rawMerchantList } = useGetAllMerchantList("ACTIVE");
  const { data: rawInstallmentSettingsList } =
    useGetInstallmentCountSettingsList({});
  const { mutate: bankInstallment } = useGetBankInstallments();
  // const { data: rawCurrencyCodeList } = useGetCurrencyCodeList({});
  const { data: rawPaymentModelList } = useGetPaymentModelSettingsList({});
  const { mutate: getMerchantRestrictionList } =
    useGetMerchantRestrictionList();
  const { mutate: paymentPreAuth, isLoading } = usePaymentPreAuth();
  const [selectedMerchantId, setSelectedMerchantId] = useState(0);
  const [installmentCounts, setInstallmentCounts] = useState([]);
  const [merchantRestrictions, setMerchantRestrictions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);

  const watchMerchantId = watch("merchantId");

  const watchCardNumber = watch("cardNumber");
  const watchTotalAmount = watch("totalAmount");
  const watchCurrency = watch("currency");

  const currencyCodeMapper = {
    TRY: "949",
    USD: "840",
    EUR: "978",
  };

  function getCurrencyCode(currencyLabel) {
    return currencyCodeMapper[currencyLabel] || ""; // Eğer eşleşme yoksa boş döner
  }
  const reverseCurrencyCodeMapper = {
    "949": "TRY",
    "840": "USD",
    "978": "EUR",
  };
  useEffect(() => {
    if (watchMerchantId) {
      getMerchantRestrictionList(
        {
          page: 0,
          size: 0,
          orderByDesc: true,
          orderBy: "CreateDate",
          merchantId: watchMerchantId,
          status: "ACTIVE",
        },
        {
          onSuccess: (response) => {
            const currencyData = response.data.result;
            let availableCurrencies = [];

            currencyData.forEach((item) => {
              ["try", "eur", "usd"].forEach((currency) => {
                if (item[currency]) {
                  const currencyLabel = currency.toUpperCase();
                  const currencyCode = getCurrencyCode(currencyLabel);
                  availableCurrencies.push({
                    label: currencyLabel, // 'TRY', 'USD' gibi
                    value: currencyCode, // '949', '840' gibi
                  });
                }
              });
            });



            const uniqueCurrencies = Array.from(
              new Set(availableCurrencies.map((e) => e.value))
            ).map((value) => {
              return {
                label: reverseCurrencyCodeMapper[value],
                value: value,
              };
            });

            setMerchantRestrictions(uniqueCurrencies);
          },
          onError: (error) => {
            console.error("Merchant restrictions fetch error", error);
          },
        }
      );
    }
  }, [watchMerchantId]);

  useEffect(() => {
    setInstallmentCounts(
      rawInstallmentSettingsList?.data?.map(
        (merchant: { key: string; value: string }) => {
          return {
            label: `${merchant.key}`,
            value: merchant.value,
          };
        }
      )
    );
  }, [rawInstallmentSettingsList?.data]);

  useEffect(() => {
    if (
      watchMerchantId &&
      watchCardNumber &&
      watchTotalAmount &&
      watchCurrency
    ) {
      // Formatlamalar
      const formattedCardNumber = watchCardNumber?.replace(/\s/g, "");
      const formattedTotalAmount = watchTotalAmount
        ?.replace(".", "")
        .replace(",", "");

      bankInstallment(
        {
          merchantId: watchMerchantId,
          cardNumber: formattedCardNumber,
          amount: formattedTotalAmount,
          currency: watchCurrency,
        },
        {
          onSuccess: (data) => {
            setIsDisabled(false);
            const transformedData = data.map((item) => {
              let label;
              if (item.installmentNumber === 0) {
                label = "Tek Çekim";
              } else {
                label = `${item.installmentNumber}`;
              }

              return {
                label: label,
                value: item.installmentNumber,
              };
            });

            setInstallmentCounts(transformedData);
          },
          onError: (error) => {
            console.error("Error fetching bank installments", error);
          },
        }
      );
    }
  }, [watchMerchantId, watchCardNumber, watchTotalAmount, watchCurrency]);

  const merchantList = useMemo(() => {
    if (userInfo.merchantId == 0) {
      return rawMerchantList?.data?.map(
        (rawPosType: { merchantName: string; merchantId: number, nonSecure: boolean }) => {
          return {
            label: rawPosType.merchantName + ` (${rawPosType.merchantId})`,
            value: rawPosType.merchantId,
            nonSecure: rawPosType.nonSecure,
          };
        }
      );
    } else {
      return rawMerchantList?.data
        ?.filter((rawPosType: { merchantName: string; merchantId: number, nonSecure: boolean }) => {
          return rawPosType.merchantId === Number(userInfo.merchantId);
        })
        .map((filteredMerchant) => {
          return {
            label: filteredMerchant.merchantName + ` (${filteredMerchant.merchantId})`,
            value: filteredMerchant.merchantId,
            nonSecure: filteredMerchant.nonSecure,
          };
        });
    }
  }, [rawMerchantList?.data, userInfo?.merchantId]);

  // const installmentCounts = useMemo(() => {
  //   return rawInstallmentSettingsList?.data?.map(
  //     (merchant: { key: string; value: string }) => {
  //       return {
  //         label: `${merchant.key}`,
  //         value: merchant.value,
  //       };
  //     }
  //   );
  // }, [rawInstallmentSettingsList?.data]);

  // const currencyCodeList = useMemo(() => {
  //   return rawCurrencyCodeList?.data?.map(
  //     (currencyCode: { value: string; key: string }) => {
  //       return {
  //         label: `${currencyCode.value}`,
  //         value: currencyCode.key,
  //       };
  //     }
  //   );
  // }, [rawCurrencyCodeList?.data]);

  const paymentModelList = useMemo(() => {
    return rawPaymentModelList?.data?.map(
      (currencyCode: { value: string; key: string }) => {
        return {
          label: `${currencyCode.key}`,
          value: `${currencyCode.key}`,
        };
      }
    );
  }, [rawPaymentModelList?.data]);

  function openInNewTabAndSubmitForm(htmlContent) {
    const newWindow = window.open("", "_blank");

    if (newWindow) {
      newWindow.document.write(htmlContent);
      newWindow.document.close();

      setTimeout(() => {
        const formNames = [
          "threeDSServerWebFlowStartForm",
          "downloadForm",
          "ddcoll",
          "ziraat",
          "hiddenForm",
        ];
        let form;
        formNames.forEach((element) => {
          let item = newWindow.document.querySelector(
            `[name="${element}"]`
          ) as unknown as HTMLFormElement;
          if (item) {
            form = item;
            return;
          }
        });
        form && form.submit();
      }, 1000);
    }
  }
  const handleGenerateId = () => {
    const newId = uuidv4();
    setValue("orderId", newId);
  };

  const onSubmit = (formValues: PreAuthAddFormValuesType) => {
    const expiryDates = formValues.lastUsingDate
      .trim()
      .replace(/\s/g, "")
      .replace(/\/+$/, "");

    const request: IPaymentPreAuthRequest = {
      cardNumber: formValues.cardNumber.trim().replace(/\s/g, ""),
      expiryDateMonth: expiryDates.charAt(0) + expiryDates.charAt(1),
      expiryDateYear: "20" + expiryDates.charAt(2) + expiryDates.charAt(3),
      cvv: formValues.cvv,
      cardHolderName: formValues.cardHolderName,
      merchantId: selectedMerchantId,
      totalAmount: formValues.totalAmount.replace(".", "").replace(",", ""),
      memberId: 1,
      txnType: "PreAuth",
      installmentCount: formValues.installmentCount !== null && formValues.installmentCount !== undefined
        ? formValues.installmentCount.toString()
        : "",
      currency: selectedCurrency,
      orderId: formValues.orderId,
      use3D: formValues.use3D === "3D" ? true : false,
    };

    paymentPreAuth(request, {
      onSuccess: (data) => {
        if (typeof data === "string" && formValues.use3D === "3D") {
          openInNewTabAndSubmitForm(data);
          // Diğer işlemler..
        } else {
          if (data.isSuccess) {
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              description: data.message || "İşlem sırasında bir hata oluştu",
              isOpen: true,
            });
          }
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  return (
    <>
      {isLoading && <Loading />}
      <Stack flex={1} justifyContent="space-between">
        <Stack flex={1} p={2}>
          <Stack spacing={4}>
            <Stack width={isDesktop ? 800 : "auto"} spacing={3} direction="row">
              <FormControl sx={{ width: isDesktop ? "49.5%" : "100%" }}>
                {merchantList && (
                  <Controller
                    control={control}
                    name="merchantId"
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <Autocomplete
                        sx={{ mr: isDesktop ? 1 : 0 }}
                        id="merchantId"
                        options={merchantList}
                        value={
                          merchantList.find(
                            (option) => option.value === value
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          const merchantValue = newValue
                            ? Number(newValue.value)
                            : null;
                          onChange(merchantValue);
                          setSelectedMerchantId(merchantValue);
                        }}
                        getOptionLabel={(option: {
                          label: string;
                          value: number;
                        }) => option.label}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Üye İşyeri"
                            error={!!error} //
                          />
                        )}
                      />
                    )}
                  />
                )}
              </FormControl>
            </Stack>
            <Stack
              width={isDesktop ? 800 : "auto"}
              spacing={3}
              direction={isDesktop ? "row" : "column"}
            >
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <InputControl
                  sx={{ flex: 1 }}
                  label="Kart Sahibinin Adı Soyadı"
                  control={control}
                  id="cardHolderName"
                  stringOnly={true}
                />
              </FormControl>
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <FormatInputControl
                  sx={{ flex: 1 }}
                  label="Kart Numarası"
                  control={control}
                  id="cardNumber"
                  format="#### #### #### ####"
                  allowEmptyFormatting
                  mask="_"
                />
              </FormControl>
            </Stack>

            <Stack
              width={isDesktop ? 800 : "auto"}
              spacing={3}
              direction="row"
            >
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <FormatInputControl
                  label="Son Kullanma Tarihi"
                  control={control}
                  id="lastUsingDate"
                  format="## / ##"
                  allowEmptyFormatting
                  mask="_"
                />
              </FormControl>
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <InputControl
                  sx={{ flex: 1 }}
                  label="CVV2"
                  control={control}
                  id="cvv"
                  numeric
                  maxLength={4}
                />
              </FormControl>
            </Stack>
            <Stack
              width={isDesktop ? 800 : "auto"}
              spacing={3}
              direction={isDesktop ? "row" : "column"}
            >
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <Controller
                  name="currency"
                  control={control}
                  defaultValue=""
                  render={({ field: { onChange, value } }) => {
                    const selectedRestriction = merchantRestrictions.find(
                      (option) => option.value === value
                    );

                    return (
                      <Autocomplete
                        id="currency"
                        options={merchantRestrictions}
                        getOptionSelected={(option, value) =>
                          option.value === value
                        }
                        getOptionLabel={(option) => option.label}
                        value={selectedRestriction || null}
                        onChange={(_, newValue) => {
                          if (newValue) {
                            setSelectedCurrency(newValue.value);
                            onChange(newValue.value);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Para Birimi" />
                        )}
                        disabled={!watchMerchantId}
                      />
                    );
                  }}
                />
              </FormControl>

              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <NumericFormatInputControl
                  sx={{ flex: 1 }}
                  label="Çekilecek Tutar"
                  control={control}
                  id="totalAmount"
                  adornmentText="TL"
                  thousandSeparator=","
                  decimalSeparator="."
                  decimalScale={2}
                  fixedDecimalScale
                />
              </FormControl>
            </Stack>
            <Stack
              width={isDesktop ? 800 : "auto"}
              spacing={3}
              direction={isDesktop ? "row" : "column"}
            >
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                {installmentCounts && (
                  <Controller
                    name="installmentCount"
                    control={control}
                    defaultValue=""
                    render={({ field: { onChange, value } }) => {
                      const selectedInstallment = installmentCounts.find(
                        (option) => option.value === value
                      );

                      return (
                        <Autocomplete
                          disabled={isDisabled}
                          id="installmentCount"
                          options={installmentCounts}
                          getOptionSelected={(option, value) =>
                            option.value === value
                          }
                          getOptionLabel={(option) => option.label}
                          value={selectedInstallment || null}
                          onChange={(_, newValue) => {
                            onChange(newValue ? newValue.value : "");
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Taksit Sayısı" />
                          )}
                        />
                      );
                    }}
                  />
                )}
              </FormControl>
              <FormControl sx={{ width: isDesktop ? "50%" : "100%" }}>
                <InputControl
                  sx={{ flex: 1 }}
                  label="Sipariş Numarası"
                  control={control}
                  removeSpaces={true}
                  id="orderId"
                  buttonAdornment={
                    <InputAdornment position="end">
                      <Button
                        onClick={handleGenerateId}
                        variant="contained"
                        sx={{
                          height: '100%',
                          minHeight: "56px",
                          width: isDesktop ? "90px" : "70px",
                          marginRight: '-21.5px',
                          borderRadius: '0 5px 5px 0',
                          boxShadow: 'none',
                          fontSize: isDesktop ? "12px" : "12px"
                        }}
                        text="Oluştur"
                      />


                    </InputAdornment>
                  }
                />
              </FormControl>
            </Stack>
            <Stack
              width={isDesktop ? 800 : "auto"}
              spacing={3}
              direction={isDesktop ? "row" : "column"}
            >
              <FormControl sx={{ width: isDesktop ? "49.5%" : "100%" }}>
                {paymentModelList && (
                  <SelectControl
                    sx={{ mr: isDesktop ? 1 : 0 }}
                    id="use3D"
                    control={control}
                    label="Ödeme Modeli"
                    items={paymentModelList.filter(item => merchantList?.find(x => x.value == selectedMerchantId)?.nonSecure ? true : item.value === "3D")}
                  />
                )}
              </FormControl>
            </Stack>
            <Stack
              direction={isDesktop ? "row" : "column"}
              justifyContent="flex-end"
              width={isDesktop ? 800 : "auto"}
            >
              {!!showCreate && (
                <Button
                  sx={{ width: 100 }}
                  onClick={handleSubmit(onSubmit)}
                  variant="contained"
                  text={"Öde"}
                />
              )}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      {html && (
        <BaseModalFor3d
          onClose={() => setIsHtmlOpen(false)}
          title={""}
          isOpen={isHtmlOpen}
        >
          <div dangerouslySetInnerHTML={{ __html: html }}></div>
        </BaseModalFor3d>
      )}
    </>
  );
};
